import { IPropsWithChildren } from '@omaze/app';
import classNames from 'classnames';
import React, { ReactElement } from 'react';

import styles from './Underline.styles.css';

export enum UnderlineTestIds {
    UNDERLINE = 'Underline__underline',
}

interface IUnderlineProps extends IPropsWithChildren {
    className?: string;
    animationStyle?: 'normal' | 'underlineRemains';
    underlineHeight?: 'small' | 'large';
    underlineRemainsColor?: 'yellow' | 'white';
}

export function Underline (props: IUnderlineProps): ReactElement {
    const {
        children,
        className = '',
        animationStyle = 'normal',
        underlineHeight = 'small',
        underlineRemainsColor = 'yellow',
    }: IUnderlineProps = props;

    return (
        <span
            data-testid={UnderlineTestIds.UNDERLINE}
            className={classNames({
                [className]: !!className,
                'group relative w-auto inline-block overflow-hidden': true,
                [styles['animate-underline']]: animationStyle !== 'underlineRemains',
                [styles['animate-underline--remains']]: animationStyle === 'underlineRemains',
                [styles['animate-underline-height--small']]: underlineHeight === 'small',
                [styles['animate-underline-height--large']]: underlineHeight === 'large',
                [styles['animate-underline-remains-color--yellow']]: underlineRemainsColor === 'yellow',
                [styles['animate-underline-remains-color--white']]: underlineRemainsColor === 'white',
            })}
        >
            {children}
        </span>
    );
}
